import { Directive, ViewContainerRef, ContentChildren, ContentChild } from '@angular/core';
import { ComplexBase, ArrayBase, setValue } from '@syncfusion/ej2-angular-base';

import { AggregateColumnsDirective } from './aggregate-columns.directive';

let /** @type {?} */ input: string[] = ['columns'];
let /** @type {?} */ outputs: string[] = [];
/**
 * `e-aggregate` directive represent a aggregate row of the Angular Grid. 
 * It must be contained in a Grid component(`ejs-grid`). 
 * ```html
 * <ejs-grid [dataSource]='data' allowPaging='true' allowSorting='true'> 
 *   <e-columns>
 *     <e-column field='ID' width='100'></e-column>
 *     <e-column field='name' headerText='Name' width='100'></e-column>
 *   </e-columns>
 *   <e-aggregates>
 *     <e-aggregate>
 *       <e-columns>
 *         <e-column field='ID' type='Min'></e-column>
 *       </e-columns>
 *      </e-aggregate>
 *    </e-aggregates>
 * </ejs-grid>
 * ```
 */
export class AggregateDirective extends ComplexBase<AggregateDirective> {
public directivePropList: any;
public childColumns: any;
public tags: string[] = ['columns'];
/**
 * Configures the aggregate columns.
 * \@default []
 */
public columns: any;
/**
 * @param {?} viewContainerRef
 */
constructor(private viewContainerRef:ViewContainerRef) {
        super();
        setValue('currentInstance', this, this.viewContainerRef);
        this.registerEvents(outputs);
        this.directivePropList = input;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: 'ejs-grid>e-aggregates>e-aggregate',
    inputs: input,
    outputs: outputs,    
    queries: {
        childColumns: new ContentChild(AggregateColumnsDirective)
    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
];
}

function AggregateDirective_tsickle_Closure_declarations() {
/** @type {?} */
AggregateDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AggregateDirective.ctorParameters;
/** @type {?} */
AggregateDirective.prototype.directivePropList;
/** @type {?} */
AggregateDirective.prototype.childColumns;
/** @type {?} */
AggregateDirective.prototype.tags;
/**
 * Configures the aggregate columns.
 * \@default []
 * @type {?}
 */
AggregateDirective.prototype.columns;
/** @type {?} */
AggregateDirective.prototype.viewContainerRef;
}

/**
 * Aggregate Array Directive
 */
export class AggregatesDirective extends ArrayBase<AggregatesDirective> {
constructor() {
        super('aggregates');
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: 'ejs-grid>e-aggregates',
    queries: {
        children: new ContentChildren(AggregateDirective)
    },
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AggregatesDirective_tsickle_Closure_declarations() {
/** @type {?} */
AggregatesDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AggregatesDirective.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
